const styles = (theme) => ({
  groupName: {
    paddingLeft: theme.spacing(2),
  },

  drawerContainer: {
    padding: theme.spacing(2),
  },

  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 'space-between',
    padding: theme.spacing(2, 0),
  },

  cancelButton: {
    marginRight: 15,
  },
});

export default styles;
